{
  "TEAMS_SETTINGS": {
    "NEW_TEAM": "Create new team",
    "HEADER": "Teams",
    "LOADING": "Fetching teams",
    "DESCRIPTION": "Teams allow you to organize agents into groups based on their responsibilities. An agent can belong to multiple teams. When working collaboratively, you can assign conversations to specific teams.",
    "LEARN_MORE": "Learn more about teams",
    "COUNT": "{n} team | {n} teams",
    "SEARCH_PLACEHOLDER": "Hľadať tímy...",
    "NO_RESULTS": "No teams found matching your search",
    "LIST": {
      "404": "There are no teams created on this account.",
      "EDIT_TEAM": "Edit team",
      "NONE": "Žiadne"
    },
    "CREATE_FLOW": {
      "CREATE": {
        "TITLE": "Create a new team",
        "DESC": "Add a title and description to your new team."
      },
      "AGENTS": {
        "BUTTON_TEXT": "Add agents to team",
        "TITLE": "Pridať agentov do tímu - {teamName}",
        "DESC": "Add Agents to your newly created team. This lets you collaborate as a team on conversations, get notified on new events in the same conversation."
      },
      "WIZARD_CREATE": {
        "TITLE": "Create",
        "BODY": "Create a new team of agents."
      },
      "WIZARD_ADD_AGENTS": {
        "TITLE": "Add Agents",
        "BODY": "Pridať agentov do tímu."
      },
      "WIZARD_FINISH": {
        "TITLE": "Hotovo",
        "BODY": "Všetko je pripravené!"
      }
    },
    "EDIT_FLOW": {
      "CREATE": {
        "TITLE": "Upravte údaje o svojom tíme",
        "DESC": "Upravte názov a popis svojho tímu.",
        "BUTTON_TEXT": "Aktualizovať tím"
      },
      "AGENTS": {
        "BUTTON_TEXT": "Aktualizovať agentov v tíme",
        "TITLE": "Pridať agentov do tímu - {teamName}",
        "DESC": "Pridajte agentov do novovytvoreného tímu. Všetci pridaní agenti budú upozornení, keď sa do tohto tímu priradí konverzácia."
      },
      "EDIT_WIZARD_DETAILS": {
        "TITLE": "Tímové detaily",
        "ROUTE": "Upraviť tímové detaily",
        "BODY": "Zmena názvu, popisu a ďalších údajov."
      },
      "EDIT_WIZARD_AGENTS": {
        "TITLE": "Upraviť agentov",
        "ROUTE": "settings_teams_edit_members",
        "BODY": "Upravte agentov vo svojom tíme."
      },
      "EDIT_WIZARD_FINISH": {
        "TITLE": "Hotovo",
        "ROUTE": "settings_teams_edit_finish",
        "BODY": "Všetko je pripravené!"
      }
    },
    "TEAM_FORM": {
      "ERROR_MESSAGE": "Nepodarilo sa uložiť údaje o tíme. Skúste to znova."
    },
    "AGENTS": {
      "AGENT": "Agent",
      "EMAIL": "Email",
      "BUTTON_TEXT": "Pridať agentov",
      "ADD_AGENTS": "Pridávajú sa agenti do tímu...",
      "SELECT": "vybrať",
      "SELECT_ALL": "vybrať všetkých agentov",
      "SELECTED_COUNT": "{selected} z {total} vybraných agentov."
    },
    "ADD": {
      "TITLE": "Pridať agentov do tímu - {teamName}",
      "DESC": "Pridajte agentov do novovytvoreného tímu. To vám umožní spolupracovať v tíme na konverzáciách a dostávať upozornenia na nové udalosti v tej istej konverzácii.",
      "SELECT": "vybrať",
      "SELECT_ALL": "vybrať všetkých agentov",
      "SELECTED_COUNT": "{selected} z {total} vybraných agentov.",
      "BUTTON_TEXT": "Pridať agentov",
      "AGENT_VALIDATION_ERROR": "Select at least one agent."
    },
    "FINISH": {
      "TITLE": "Váš tím je pripravený!",
      "MESSAGE": "Na konverzáciách teraz môžete spolupracovať ako tím. Šťastná podpora ",
      "BUTTON_TEXT": "Hotovo"
    },
    "DELETE": {
      "BUTTON_TEXT": "Vymazať",
      "API": {
        "SUCCESS_MESSAGE": "Tím úspešne odstránený.",
        "ERROR_MESSAGE": "Tím sa nepodarilo vymazať! Skúste to znova."
      },
      "CONFIRM": {
        "TITLE": "Are you sure you want to delete the team?",
        "PLACE_HOLDER": "Pre potvrdenie zadajte {teamName}",
        "MESSAGE": "Odstránením tímu sa odstráni priradenie tímu z konverzácií priradených k tomuto tímu.",
        "YES": "Vymazať ",
        "NO": "Zrušiť"
      }
    },
    "SETTINGS": "Nastavenia",
    "FORM": {
      "UPDATE": "Aktualizovať tím",
      "CREATE": "Vytvoriť tím",
      "NAME": {
        "LABEL": "Názov tímu",
        "PLACEHOLDER": "Príklad: Predaj, zákaznícka podpora"
      },
      "DESCRIPTION": {
        "LABEL": "Popis tímu",
        "PLACEHOLDER": "Krátky popis tohto tímu."
      },
      "AUTO_ASSIGN": {
        "LABEL": "Allow auto assign for this team."
      },
      "SUBMIT_CREATE": "Vytvoriť tím"
    }
  }
}
